import React, { useState, useEffect } from 'react';
import { Input, Button, Card, CardBody, CardHeader, Col, Container, ListGroup, ListGroupItem, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import { Link } from 'react-router-dom';
import Pagination from '../ChatBot_List_Grid_Cust/Pagination';
import { useDispatch , useSelector } from 'react-redux';
import { GET_GROUP_USER_DETAILS } from '../../slices/thunks';
import config from '../../config';
import Loader from '../../Components/Common/Loader';

const Gd_User_List = ({ group_id }) => {
    const dispatch = useDispatch();
    const { Data , Total_Records , Total_Pages } = useSelector((state) => state.GroupOwner.Group_User_Details_List);
    const {loading } = useSelector((state) => state.GroupOwner);
    
    const [filter, setfilter] = useState({
        page: 1,
        per_page: config.general_config.PER_PAGE_CONTENT,
        sort_by: null,
        sort_order: null,
        search_user_name: null,
        search_email_id: null,
        search_user_role: null,
        search_bot_access: null
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setfilter((prevState) => ({
            ...prevState,
            [name]: value,
            page: 1 // Reset to first page when the filter changes
        }));
    };

    const onPageChange = (page_number) => {
        let filter_temp = filter;
        filter_temp.page = Number.parseInt(page_number);
        setfilter(filter_temp);
        dispatch(GET_GROUP_USER_DETAILS({ group_id, ...filter_temp }));
    };

    useEffect(() => {
        dispatch(GET_GROUP_USER_DETAILS({ group_id, ...filter }));
    }, [group_id, filter]);

    const set_sort = ({ sort_column  })=>{
        if(sort_column === filter.sort_by){
            if(filter.sort_order == 'ASC'){
                setfilter({ ...filter , sort_order:'DESC' , sort_by:sort_column })
            }else{
                setfilter({ ...filter , sort_order:'ASC' , sort_by:sort_column  })
            }
        }
        else{
            setfilter({ ...filter , sort_order:'ASC' , sort_by:sort_column })
        }
    }

    return (
        <>
            <div className="listjs-table" id="user_list_detail">
                <div className="table-responsive mb-1">
                    <table className="table align-middle table-nowrap" id="customerTable">
                        <thead className="table-light">
                            <tr>
                                <th></th>
                                <th className="sort" onClick={() => set_sort({ sort_column: 'User_Name' })}  data-sort="user_name">User Name
                                    <div className="input-group">
                                        <Input
                                            type="text"
                                            name="search_user_name"
                                            value={filter.search_user_name || ''}
                                            className="form-control"
                                            placeholder="Search Username"
                                            onChange={handleInputChange}
                                        />
                                        <span className="input-group-text" id="user_name"><i className='ri-search-line'></i></span>
                                    </div>
                                </th>
                                <th className="sort" onClick={() => set_sort({ sort_column: 'Email' })} data-sort="email">Email
                                    <div className="input-group">
                                        <Input
                                            type="text"
                                            name="search_email_id"
                                            value={filter.search_email_id || ''}
                                            className="form-control"
                                            placeholder="Search Email"
                                            onChange={handleInputChange}
                                        />
                                        <span className="input-group-text" id="email"><i className='ri-search-line'></i></span>
                                    </div>
                                </th>
                                <th className="sort" onClick={() => set_sort({ sort_column: 'User_Role' })}>User Type
                                    <div className="input-group">
                                        <Input
                                            type="text"
                                            name="search_user_role"
                                            value={filter.search_user_role || ''}
                                            className="form-control"
                                            placeholder="Search User Role"
                                            onChange={handleInputChange}
                                        />
                                        <span className="input-group-text" id="usertype"><i className='ri-search-line'></i></span>
                                    </div>
                                </th>
                                <th className="sort" onClick={() => set_sort({ sort_column: 'BotAccess' })} data-sort="botaccess">Bot Access
                                    <div className="input-group">
                                        <Input
                                            type="text"
                                            name="search_bot_access"
                                            value={filter.search_bot_access || ''}
                                            className="form-control"
                                            placeholder="Search Bot Access"
                                            onChange={handleInputChange}
                                        />
                                        <span className="input-group-text" id="botaccess"><i className='ri-search-line'></i></span>
                                    </div>
                                </th>

                                <th  onClick={() => set_sort({ sort_column: 'BotAccess' })} >
                                    <div className='d-flex'>Invitation Status</div>
                                    <div className="input-group" style={{visibility:'hidden', width:'100px'}}>
                                         <Input
                                            type="text"
                                            name="search_bot_access"
                                            value={filter.search_bot_access || ''}
                                            className="form-control"
                                            placeholder="Search Bot Access"
                                            onChange={handleInputChange}
                                        /> 
                                      
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        {loading ? <Loader/> : <tbody className="list form-check-all">
                            {
                                Data?.map((value, key) => {
                                    const { User_Group_ID, User_Role, User_Name, User_ID, Email, User_Image, BotAccess , Invite_Acceptance_Status } = value;
                                    return (
                                        <tr key={key}>
                                            <td><span className='text-secondary'><i class="mdi mdi-lead-pencil"></i></span></td>
                                            <td className="id" style={{ display: "none" }}><Link to="#" className="fw-medium link-primary">#VZ2101</Link></td>
                                            <td className="user_name">{User_Name}</td>
                                            <td className="email">{Email}</td>
                                            <td className="usertype"><span className="rounded-pill btn-outline-primary-cust">{User_Role}</span></td>
                                            <td className="botaccess">{BotAccess}</td>
                                            <td className="botaccess">{Invite_Acceptance_Status ? "Accepted":"Pending"}</td>

                                        </tr>
                                    );
                                })
                            }
                        </tbody>}
                    </table>
                    <div className="noresult" style={{ display: "none" }}>
                        <div className="text-center">
                            <lord-icon src="https://cdn.lordicon.com/msoeawqm.json" trigger="loop"
                                colors="primary:#121331,secondary:#08a88a" style={{ width: "75px", height: "75px" }}>
                            </lord-icon>
                            <h5 className="mt-2">Sorry! No Result Found</h5>
                            <p className="text-muted mb-0">We've searched more than 150+ Orders We did not find any orders for your search.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="d-flex justify-content-end">
                <Pagination onPageChange={onPageChange} total_pages={Total_Pages} current_page={filter.page} />
            </div>
        </>
    );
};

export default Gd_User_List;
